export const PaymentType = {
  0: 'Interbancario',
  1: 'Paypal',
  2: 'Tarjeta',
  3: 'Gratis',
  4: 'Tarjeta una vez'
};
